import React, {FC} from "react"

import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import perksNearMe from "@irati/ui/images/perks-near-me.svg"
import Flex from "@irati/ui/src/Flex"
import {Body, H2} from "@irati/ui/src/Typography"

import {HeaderWrapper, Image} from "./styled"

interface Props {}

const PerksNearMeHeader: FC<Props> = () => (
  <Flex alignItems="center">
    <Image src={perksNearMe} />
    <HeaderWrapper>
      <H2>
        <FormattedMessage id="perks.searchByLocation.perksGONearMe.header" />
      </H2>
      <Body small margin={[1, 0, 0]}>
        <FormattedMessage id="perks.searchByLocation.perksGONearMe.subheader" />
      </Body>
    </HeaderWrapper>
  </Flex>
)

export default React.memo(injectIntl(PerksNearMeHeader))
